import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';
import { t } from 'i18n';

import { LayoverDuration, SegmentDuration } from './helpers';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
  `,
  segmentDetails: css`
    font-size: ${tokens.fontSize.paragraph['paragraph-3']};
    font-weight: 700;
    text-wrap: nowrap;
  `,
  duration: css`
    display: flex;
    gap: ${tokens.dimension['space-2']};
    font-size: ${tokens.fontSize.paragraph['paragraph-2']};
    line-height: ${tokens.lineHeight.paragraph['paragraph-3']};
  `,
  layover: css`
    margin-top: ${tokens.dimension['space-4']};
    margin-bottom: ${tokens.dimension['space-4']};
    text-wrap: nowrap;
  `,
};

export const DurationSegmentPopup = ({ duration, departure, arrival, flightNumber, operatedBy }: SegmentDuration) => (
  <>
    <div css={styles.segmentDetails}>
      {`${departure.name} ${departure.airportName} ${departure.code}`}
      <> &ndash; </>
      {`${arrival.name} ${arrival.airportName} ${arrival.code}`}
    </div>
    <div css={styles.duration}>
      <span>
        {departure.time} - {arrival.time} (
        {`${t('formattedTime', { hours: duration.hours, minutes: duration.minutes })}`}) {'|'} {operatedBy} {'|'}{' '}
        {flightNumber}
      </span>
    </div>
  </>
);

export const DurationLayoverPopup = ({ duration }: LayoverDuration) => (
  <div css={styles.layover}>
    {`${t('common:timeBetweenFlights')}`}
    {': '}
    {`${t('formattedTime', { hours: duration.hours, minutes: duration.minutes })}`}
  </div>
);
